// extracted by mini-css-extract-plugin
module.exports = {"currentPage":"Users_currentPage__2C6PQ","paginationIem":"Users_paginationIem__2k1g7","userAva":"Users_userAva__1IXUy"};